import { isDesktopQuery, ImageFormat, cdnService, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BREAKPOINT_DEVICE_UPDATED, AFFILIATE_QUERY, Feature } from '@gig/magic-messages';
import { OFFER_NAMESPACE } from '../../store/modules/offer/offer.store.js';
import { store } from '../../store/index.js';

var offers = namespace(OFFER_NAMESPACE);
/**
 * Component displaying offer card. Can be used e.g. in sign up
 */
var OfferCard = /** @class */ (function (_super) {
    __extends(OfferCard, _super);
    function OfferCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isCustomOfferEnabled = false;
        /**
         * Affiliate tag for the offer
         */
        _this.affiliateTag = '';
        /**
         * Represents if it should show the offer image or not.
         */
        _this.showImage = false;
        _this.breakpointSubscription = null;
        return _this;
    }
    OfferCard.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, window.queryBus.query(AFFILIATE_QUERY)];
                    case 1:
                        _b.affiliateTag =
                            (_a = (_c.sent())) !== null && _a !== void 0 ? _a : '';
                        this.breakpointSubscription = window.eventBus.subscribe(BREAKPOINT_DEVICE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!event.payload) {
                                            return [2 /*return*/, null];
                                        }
                                        _a = this;
                                        return [4 /*yield*/, isDesktopQuery()];
                                    case 1:
                                        _a.showImage = _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true });
                        this.loadOffer();
                        return [2 /*return*/];
                }
            });
        });
    };
    OfferCard.prototype.destroyed = function () {
        var _a;
        (_a = this.breakpointSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Object.defineProperty(OfferCard.prototype, "offer", {
        get: function () {
            var language = this.magicConfig.language;
            return this.getOffersByAffiliate(this.slug, this.affiliateId || '', language)[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferCard.prototype, "src", {
        get: function () {
            return this.getImage(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferCard.prototype, "avifSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.AVIF);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferCard.prototype, "webpSrcset", {
        get: function () {
            return this.getImageSrcset(ImageFormat.WEBP);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OfferCard.prototype, "affiliateId", {
        get: function () {
            if (!this.affiliateTag || !this.isCustomOfferEnabled) {
                return '';
            }
            return this.affiliateTag.split('_')[0];
        },
        enumerable: false,
        configurable: true
    });
    OfferCard.prototype.getImageSrcset = function (format) {
        return this.getImage(format) + ", " + this.getImage(format, true) + " 2x";
    };
    OfferCard.prototype.getImage = function (format, retina) {
        if (retina === void 0) { retina = false; }
        if (!this.offer || !this.offer.image) {
            return '';
        }
        return cdnService.getOfferImageUrl(this.offer.image, {
            width: this.imageWidth,
            quality: 100,
            retina: retina,
            format: format,
        });
    };
    OfferCard.prototype.loadOffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!!this.affiliateTag) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchOffer({
                                lang: this.magicConfig.language,
                                slug: this.slug,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.fetchAllOffers({ lang: this.magicConfig.language })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.CUSTOM_WELCOME_OFFER_BASED_ON_BTAG,
        }),
        __metadata("design:type", Object)
    ], OfferCard.prototype, "isCustomOfferEnabled", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], OfferCard.prototype, "slug", void 0);
    __decorate([
        Prop({ type: Number, default: 320 }),
        __metadata("design:type", Number)
    ], OfferCard.prototype, "imageWidth", void 0);
    __decorate([
        offers.Getter('getOffersByAffiliate'),
        __metadata("design:type", Function)
    ], OfferCard.prototype, "getOffersByAffiliate", void 0);
    __decorate([
        offers.Action('fetchAllOffers'),
        __metadata("design:type", Function)
    ], OfferCard.prototype, "fetchAllOffers", void 0);
    __decorate([
        offers.Action('fetchOffer'),
        __metadata("design:type", Function)
    ], OfferCard.prototype, "fetchOffer", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], OfferCard.prototype, "loadOffer", null);
    OfferCard = __decorate([
        Component({
            name: 'offer-card',
            store: store,
        })
    ], OfferCard);
    return OfferCard;
}(Mixins(MagicConfigMixin)));

export default OfferCard;
